import React, { useState, useEffect, useRef } from 'react';

import Navigation from '../Navigation/Navigation';
import MusicPlayer from '../Tools/MusicPlayer';
import BottomPlayBar from '../Tools/BottomPlayBar';

// import BrandsBanner from '../Tools/BrandsBanner';

import profpic from '../../Images/Andy.jpeg';
import liesl from '../../Images/musical/liesl.jpeg';
import pic1 from '../../Images/musical/1.jpeg';
import pic2 from '../../Images/musical/2.jpeg';
import pic3 from '../../Images/musical/3.jpeg';
import pic4 from '../../Images/musical/4.jpeg';
import pic5 from '../../Images/musical/5.jpeg';
import pic6 from '../../Images/musical/6.jpeg';
// import BANNER2 from '../../Images/musical/banner2.jpeg';
// import BANNER3 from '../../Images/musical/banner3.png';

import Stalled_Opener from '../../Audio/musical/1_Stalled_Opener.mp3';
import All_Clean_All_Better from '../../Audio/musical/2_All_Clean_All_Better.mp3';
import Slow_Down from '../../Audio/musical/3_Slow_Down.mp3';
import Someone_Elses_Life from '../../Audio/musical/4_Someone_Elses_Life.mp3';
import Hurricane_Sophie from '../../Audio/musical/5_Hurricane_Sophie.mp3';
import Hotline from '../../Audio/musical/6_1800.mp3';
import Just_Stop from '../../Audio/musical/7_Just_Stop.mp3';
import Different_Not_Broken from '../../Audio/musical/8_Different_Not_Broken.mp3';
import Happy_Hurt_Day from '../../Audio/musical/9_Happy_Hurt_Day.mp3';
import Fall_From_Grace from '../../Audio/musical/10_Fall_From_Grace.mp3';
import Candy_Apple_Joy from '../../Audio/musical/11_Candy_Apple_Joy.mp3';
import Sing_Me_Down_The_Road_Ending from '../../Audio/musical/12_Sing_Me_Down_The_Road_Ending.mp3';

// const BANNER = 'https://images.pexels.com/photos/2426085/pexels-photo-2426085.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
// const BANNER = 'https://images.pexels.com/photos/3709369/pexels-photo-3709369.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

// const curtains = 'https://images.pexels.com/photos/4722577/pexels-photo-4722577.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';
const curtains = 'https://images.pexels.com/photos/3709369/pexels-photo-3709369.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2';

const imageArray = [pic1,pic2,pic3,pic4,pic5,pic6];
const songArray = [
	{audio:Stalled_Opener,name:'1. Stalled (Opener)'},
	{audio:All_Clean_All_Better,name:'2. All Clean, All Better'},
	{audio:Slow_Down,name:'3. Slow Down'},
	{audio:Someone_Elses_Life,name:`4. Someone Else's Life`},
	{audio:Hurricane_Sophie,name:'5. Hurricane Sophie'},
	{audio:Hotline,name:'6. 1800'},
	{audio:Just_Stop,name:'7. Just Stop'},
	{audio:Different_Not_Broken,name:'8. Different Not Broken'},
	{audio:Happy_Hurt_Day,name:'9. Happy Hurt Day'},
	{audio:Fall_From_Grace,name:'10. Fall From Grace'},
	{audio:Candy_Apple_Joy,name:'11. Candy Apple Joy'},
	{audio:Sing_Me_Down_The_Road_Ending,name:'12. Sing Me Down The Road (Ending)'},

];

const Musical = ({dimensions,width,navigate}) => {
	const [ selected, setSelected ] = useState(0);
	const [ playing, setPlaying ] = useState('');
	const [ playBack, setPlayBack ] = useState(0);

	const audioRef = useRef();

	useEffect(()=>{window.scrollTo(0, 0);},[]);

	function playPressed(e,i) {
		const audio = document.getElementById(e);
		if(playing.id === e){
			if(playing.play === true){
				audio.pause();
				setPlaying({id:e,i:i,play:false});
			} else {
				audio.play();
				setPlaying({id:e,i:i,play:true});
			}
		} else {
			// stop previously playing song if playing
			if(playing.play === true){
				const audio_old = document.getElementById(playing.id);
				audio_old.pause();
			}
			audio.play();
			setPlaying({id:e,i:i,play:true});
		}
	}

	function scrollToAbout() {
		const element = document.getElementById('about_div');
		const y = element.getBoundingClientRect().top + window.scrollY-100;
		window.scroll({
			top: y,
			behavior: 'smooth'
		});
	}
	function scrollToArtists() {
		const element = document.getElementById('artist_div');
		const y = element.getBoundingClientRect().top + window.scrollY-100;
		window.scroll({
			top: y,
			behavior: 'smooth'
		});
	}
	function scrollToMusic() {
		const element = document.getElementById('music_div');
		const y = element.getBoundingClientRect().top + window.scrollY-100;
		window.scroll({
			top: y,
			behavior: 'smooth'
		});
	}

	function photoLooper() {
		let arr = [];
		for(let i = 0; i < imageArray.length; i++){
			let className = 'flexCenter pointer hoverOpacityUp'
			if(selected === i) className = 'flexCenter pointer';
			if(dimensions.width < 700){
				arr.push(
					<div key={i} style={{width:width/imageArray.length-1,height:width/imageArray.length*0.9,overflow:'hidden',
							background:'black',borderRight:'1px solid white'}} className={className}
							onClick={()=>{setSelected(i)}}>
						<img src={imageArray[i]} alt='musical' style={{height:'100%'}} />
					</div>
				)
			} else {
				arr.push(
					<div key={i} style={{width:width/imageArray.length-1,height:width/imageArray.length*0.6,overflow:'hidden',
							background:'black',borderRight:'1px solid white'}} className={className}
							onClick={()=>{setSelected(i)}}>
						<img src={imageArray[i]} alt='musical' style={{width:'100%'}} />
					</div>
				)
			}
		}
		return(
			<div style={{borderRadius:12,overflow:'hidden'}}>
				<div style={{width:width,height:width*0.6,overflow:'hidden',borderBottom:'1px solid white'}} className='flexCenter'>
					<img src={imageArray[selected]} alt='musical' style={{height:'120%'}} />
				</div>
				<div className='flexHeightCenter'>{arr}</div>
			</div>
		)
	}
	function musicLoop() {
		let arr = [];
		for(let i = 0; i < songArray.length; i++){
			arr.push(
				<div key={i}><MusicPlayer song={songArray[i]} i={i} id={songArray[i].name} playPressed={playPressed}
						playing={playing} width={width} dimensions={dimensions} audioRef={audioRef}
						playBack={playBack} setPlayBack={setPlayBack} /></div>
			)
		}
		return arr;
	}
	return(
		<div>
			<Navigation navigate={navigate} width={width} />
			<div style={{height:60}}></div>

			{/*<div style={{height:dimensions.height-60,overflow:'hidden',zIndex:0,background:'rgb(206,164,143)'}} className='flexCenter absolute'>
				<img src={BANNER3} alt='BANNER2' style={{width:dimensions.width+280,filter:'blur(24px)'}} />
			</div>
			<div style={{height:dimensions.height-60,overflow:'hidden',zIndex:2}} className='flexCenter relative'>
				{dimensions.width < dimensions.height+160
					? <img src={BANNER2} alt='BANNER2' style={{height:dimensions.height}} />
					: <img src={BANNER3} alt='BANNER2' style={{width:dimensions.width+80,marginLeft:-80}} />
				}
			</div>*/}

			<div style={{height:dimensions.width < dimensions.height-60 ? dimensions.width : dimensions.height-60,width:dimensions.width,overflow:'hidden',
					zIndex:3,backgroundImage:'linear-gradient(rgba(0,0,0,0), black)',pointerEvents:'none'}} className='flexCenter absolute'>
				<div style={{color:'white',width:width,textShadow:'0px 0px 8px rgba(0,0,0,0.5)'}}>
					<div style={{height:50}}></div>
					<div className='heroText bold'>STALLED: A MODERN FEMINIST MUSICAL</div>
					<div className='heading boldX'>About mothers, daughters and moving on</div>
					<div className='subHeading' style={{marginTop:20}}>
						Created by, book and lyrics by Liesl Wilke. Music and lyrics by Andy Marsh.
						{/*Created by Liesl Wilke, music by Andy Marsh*/}
					</div>
				</div>
			</div>
			<div style={{height:dimensions.width < dimensions.height-60 ? dimensions.width : dimensions.height-60,width:dimensions.width,overflow:'hidden',
					zIndex:4,color:'white'}} className='flexHeightBottom absolute'>
				<div className='flexCenter mainText' style={{width:dimensions.width}}>
					<div className='pointer underlineHover' style={{padding:12}} onClick={scrollToAbout}>About</div>
					<div className='pointer underlineHover' style={{padding:12}} onClick={scrollToArtists}>Creators</div>
					<div className='pointer underlineHover' style={{padding:12}} onClick={scrollToMusic}>Music</div>
				</div>
			</div>

			<div style={{height:dimensions.width < dimensions.height-60 ? dimensions.width : dimensions.height-60,overflow:'hidden',zIndex:2,
					background:'black'}} className='flexCenter relative'>
				{dimensions.width*0.72 < dimensions.height
					? <img src={pic6} alt='BANNER2' style={{height:'100%'}} />
					: <img src={pic6} alt='BANNER3' style={{width:dimensions.width}} />
				}
			</div>
			<div style={{height:40}}></div>

			{/*<div style={{width:'100%',height:240,overflow:'hidden'}} className='flexCenter'>
				<img src={BANNER} alt='BANNER' style={{width:'100%'}} />
			</div>
			<div style={{height:40}}></div>*/}
			
			<div style={{width:width,margin:'auto'}} className='riseUp'>
				{/*<div style={{height:20}}></div>*/}
				<div className='flexLeftxx'>
					{/*<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',marginRight:30}} className='flexCenter'>
						<img src={profpic} alt='profpic' style={{width:'100%'}} />
					</div>*/}
					{/*<div style={{width:width-150}}>*/}
						{/*<div className='heading bold' style={{marginBottom:10}}>STALLED: A MODERN FEMINIST MUSICAL</div>*/}
						{/*<div className='subHeading fadeIn bold' style={{marginBottom:10}}>Created by, book and lyrics by Liesl Wilke. Music and lyrics by Andy Marsh.</div>*/}
						{/*<div className='subHeading fadeIn' style={{textAlign:'center'}}>Ten women of all ages and walks of life share their struggles with motherhood, identity, telling the truth, grief, forgiveness and learning to let go.</div>*/}

						<div className='subHeading bold flexCenter' style={{marginBottom:20}} id='about_div'>What is STALLED?</div>
						<div className='mainText' style={{textAlign:'center'}}>STALLED is a play that uses music and spoken word to explore the multi-layered nature of the lives of women. Set in a bougie building’s executive ladies room in Seattle, four very different women, all stuck and searching and ready to find their way forward, collide in small ways as we learn what they’re each hiding from. As the story unfolds, some women connect overtly, others symbolically, as they see each other in themselves and find the courage to tell their respective truths about motherhood, daughterhood, addiction, loss, identity, and love.</div>
					{/*</div>*/}
				</div>
				<div style={{height:40}}></div>
				{photoLooper()}

				<div style={{height:60}}></div>
			</div>


			<div className='absolute flexCenter' style={{width:dimensions.width,height:420,zIndex:0,overflow:'hidden',background:'black'}}>
				<img src={curtains} alt='pic6' style={{width:'100%',filter:'blur(2px)',opacity:1}} />
			</div>

			<div style={{zIndex:3,color:'white'}} className='relative'>
				<div style={{height:60}}></div>
				<div className='subHeading bold flexCenter' style={{marginBottom:20}}>(Un)STALLED in Development</div>
				<div className='mainText' style={{width:width,margin:'auto',textAlign:'center'}}>STALLED grew from an award-winning short story by Liesl Wilke about women in a mall bathroom in New Jersey who all could use someone but have no clue how to reach out (“Stalled Symphony”, Carve Magazine, 2011). The story was developed into a television series pilot set in Seattle, in which the women were (finally) allowed to connect, to be friends, to move forward. A dear friend in LA (bless you, Jimmy!) called Liesl one day and said: “You should adapt this into a musical!” and she said, um, yes! And then mere days later met Andy Marsh, a brilliant composer with film scoring and original songwriting experience galore who’d always wanted to write a musical. They began writing lyrics together for the music Andy composed for the moments in the play when the characters just had to sing. In the summer of 2020, Marilyn Fox of Pacific Residents Theater in Venice, CA directed an online workshop and reading of the play. Songs were played during the reading from prerecorded tracks, and Liesl and Andy collected feedback from friends, writers, musicians and mentors. Liesl began revising the script with Tom Bryant, gifted dramaturg, and she and Andy completed the remaining musical numbers in 2021. A first staged production of STALLED rolled out  at Pacific Resident Theater, where these ladies were finally brought to life in April, 2022.  (www.pacificresidenttheatre.com)</div>
			</div>


			<div style={{width:width,margin:'auto'}} className='riseUp'>
				<div style={{height:120}}></div>

				<div style={{height:20}}></div>

				<div className='subHeading bold flexCenter' id='artist_div'>The Artists Behind “Stalled”</div>
				<div style={{height:30}}></div>

				{dimensions.width <= 940
					? <div style={{textAlign:'center'}}>
						<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',margin:'auto'}} className='flexCenter'>
							<img src={liesl} alt='liesl' style={{height:'100%'}} />
						</div>
						<div className='subHeading bold' style={{padding:16}}>Liesl Wilke</div>
						<div className='mainText'>Book writer and co-lyricist (created by and adapted from her short story, “Stalled Symphony” (Carve Magazine 2011). She is a former lawyer and award-winning author of novels (Circle of Three, Reader’s Digest Self-Publishing Contest Winner), Unfurling Lily (PNWA winner), Jordan Falls, and short stories appearing in Narrative Magazine, Carve Magazine, Happy, Short Story and the G.W. Review. STALLED is also a television show under development and written by Ms. Wilke, who writes television dramas on subjects ranging from the Seattle tech scene to growing up in the 80s in a family with an Open Marriage.</div>
						
						<div style={{height:20}}></div>
						<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',margin:'auto'}} className='flexCenter'>
							<img src={profpic} alt='liesl' style={{height:'100%'}} />
						</div>
						<div className='subHeading bold' style={{padding:16}}>Andy Marsh</div>
						<div className='mainText'>Composer and lyricist. Mr. Marsh scores films, freelance composes for film and television, and writes and produces his own solo work. Credits include: “Conducting a Revolution” (commissioned by Bvlgari, debuted at Tribeca), “This Is Our Home” (Horror/romance, streaming on Amazon), “Gabe” (Documentary about a young man living with Muscular Dystrophy, streaming on Amazon), and original music for Netflix’s “The Kissing Booth 2”. He’s worked with musical labels such as Atlantic’s APG, Crush Records, Pulse Music, and written with/for musicians such as: Charlie Puth, Akon, and FloRida.</div>
					</div>
					: <div className='flexCenter' style={{textAlign:'center'}}>
						<div style={{width:'48%'}}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',margin:'auto'}} className='flexCenter'>
								<img src={liesl} alt='liesl' style={{height:'100%'}} />
							</div>
							<div className='subHeading bold' style={{padding:16}}>Liesl Wilke</div>
							<div className='mainText'>Book writer and co-lyricist (created by and adapted from her short story, “Stalled Symphony” (Carve Magazine 2011). She is a former lawyer and award-winning author of novels (Circle of Three, Reader’s Digest Self-Publishing Contest Winner), Unfurling Lily (PNWA winner), Jordan Falls, and short stories appearing in Narrative Magazine, Carve Magazine, Happy, Short Story and the G.W. Review. STALLED is also a television show under development and written by Ms. Wilke, who writes television dramas on subjects ranging from the Seattle tech scene to growing up in the 80s in a family with an Open Marriage.</div>
						</div>
						<div style={{width:'4%'}}></div>
						<div style={{width:'48%'}}>
							<div style={{width:120,height:120,borderRadius:120,overflow:'hidden',margin:'auto'}} className='flexCenter'>
								<img src={profpic} alt='liesl' style={{height:'100%'}} />
							</div>
							<div className='subHeading bold' style={{padding:16}}>Andy Marsh</div>
							<div className='mainText'>Composer and lyricist. Mr. Marsh scores films, freelance composes for film and television, and writes and produces his own solo work. Credits include: “Conducting a Revolution” (commissioned by Bvlgari, debuted at Tribeca), “This Is Our Home” (Horror/romance, streaming on Amazon), “Gabe” (Documentary about a young man living with Muscular Dystrophy, streaming on Amazon), and original music for Netflix’s “The Kissing Booth 2”. He’s worked with musical labels such as Atlantic’s APG, Crush Records, Pulse Music, and written with/for musicians such as: Charlie Puth, Akon, and FloRida.</div>
						</div>
					</div>
				}
				<div style={{height:60}}></div>
				<div className='subHeading bold flexCenter' id='music_div'>Music</div>
				<div style={{height:20}} className='borderBottomX'></div>
				{musicLoop()}
				<div style={{height:20}}></div>

				<div className='flexCenter pointer underlineHover' style={{marginTop:60,color:'rgb(105,175,255)'}}
						onClick={()=>{window.open('https://www.stalledmusical.com/')}}>Learn more</div>

				<div style={{height:180}}></div>
			</div>
			<BottomPlayBar width={width} playing={playing} playPressed={playPressed} route={'/musical'}
					audioRef={audioRef} playBack={playBack} dimensions={dimensions} />
		</div>
	)
}

export default Musical;